<template>
  <div>
    <v-chart v-if="embed" :option="options" :init-options="{renderer: 'svg'}" autoresize style="width: 100%;"/>
    <text-box v-else :label="`Marketing KPI Contribution by Microaudience (${unit})`" icon="chart-bar">
      <template v-slot:info v-if="precision">
        <percent-chip :value="precision" :best="100" icon="mdi-bullseye-arrow"/>
      </template>
      <template v-slot:info-dialog>
        Projected KPI contribution by demographic micro audiences
      </template>
      <v-chart :option="options" :init-options="{renderer: 'svg'}" autoresize style="width: 100%;"/>
    </text-box>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'zrender/lib/svg/svg'
import numbro from 'numbro'

import TextBox from '@/components/TextBox.vue'
import PercentChip from '@/components/PercentChip.vue'

export default {
  data () {
    return {}
  },
  computed: {
    options () {
      return {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          show: true,
          formatter: this.formatEchartsValue
        },
        xAxis: {
          type: 'category',
          splitLine: {
            show: false
          },
          axisLabel: {
            rotate: 75
          },
          data: this.slice ? this.data.names.slice(0, this.slice) : this.data.names
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLabel: {
            formatter: this.formatValue
          }
        },
        series: {
          name: 'KPI',
          type: 'bar',
          label: {
            show: false,
            position: 'top',
            formatter: this.formatEchartsValue
          },
          itemStyle: {
            color: '#6950a1'
          },
          data: this.slice ? this.data.values.slice(0, this.slice) : this.data.values
        }
      }
    },
    total: function () {
      return this.data.values.reduce((a, b) => a + b)
    }
  },
  methods: {
    formatValue: function (value) {
      return numbro(value).format({
        average: true,
        lowPrecision: false,
        mantissa: 1,
        optionalMantissa: true
      })
    },
    formatEchartsValue: function (obj) {
      if (this.total > 0) {
        return `${this.formatValue(obj.value)} (${Math.round(100 * obj.value / this.total)}%)`
      } else {
        return '0 (0%)'
      }
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    precision: {
      type: Number,
      required: false
    },
    embed: {
      type: Boolean,
      required: false
    },
    slice: {
      type: Number,
      required: false
    },
    unit: {
      type: String,
      required: false,
      default: function () {
        return 'USD'
      }
    }
  },
  components: {
    'v-chart': ECharts,
    TextBox,
    PercentChip
  }
}
</script>
